import { ProcessStep } from '@/types'

/**
 * How It Works - Our process steps
 */
export const processSteps: ProcessStep[] = [
  {
    stepNumber: 1,
    title: 'Discovery & Consultation',
    description: 'We learn about your plumbing business, goals, target customers, and what makes you unique. This helps us create a website strategy tailored to your needs.',
    icon: 'Chat',
  },
  {
    stepNumber: 2,
    title: 'Design & Build',
    description: "Our team designs and develops your custom website with your brand, services, and conversion goals in mind. You'll review and approve before we finalize.",
    icon: 'Code',
  },
  {
    stepNumber: 3,
    title: 'Launch & Generate Leads',
    description: 'Your site goes live with all the tools needed to generate leads: contact forms, click-to-call buttons, SEO optimization, and more. Then we monitor and support your success.',
    icon: 'Rocket',
  },
]
